import React from 'react'
import PropTypes from 'prop-types'

const ListItemNode = ({ attributes, children }) => (
  <li {...attributes}>
    {children}
  </li>
)

ListItemNode.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node
}

export default ListItemNode



// WEBPACK FOOTER //
// ./src/components/ListSlatePlugin/ListItemNode.js